// extracted by mini-css-extract-plugin
export default {"container":"ko-z","brandName":"lo-z","productName":"mo-z","productNamePdpEnhancements":"no-z","breakLongProductName":"oo-z"};